import React, { useState, useEffect } from 'react';
import {
  Modal, Button, Table, Spinner, Badge,
} from 'react-bootstrap';
import { get } from '../../../Services/API';
import thousandSeparator from '../../../Utils/numberFormat';
import { BOOKING_TYPE_LABELS } from '../../../config/bookingConstants';

function LinkedBookingSelectorModal({
  order,
  show,
  handleClose,
  onSelectBooking,
}) {
  const [linkedBookings, setLinkedBookings] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLinkedBookings = async () => {
      if (!show || !order?.linked_booking_ids?.length) {
        setLinkedBookings([]);
        setLoading(false);
        return;
      }

      setLoading(true);
      try {
        const response = await get('/bookings', {
          filters: { _id: { $in: order.linked_booking_ids } },
        });
        const documents = response.data?.data?.documents || [];
        setLinkedBookings(documents);
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Error fetching linked bookings:', err);
        setLinkedBookings([]);
      } finally {
        setLoading(false);
      }
    };

    fetchLinkedBookings();
  }, [show, order?.linked_booking_ids]);

  // Combine current order with linked bookings for display
  const allBookings = [order, ...linkedBookings];

  const handleSelect = (booking) => {
    onSelectBooking(booking);
    handleClose();
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          <i className="fa fa-link me-2" />
          Select Booking for Voucher
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text-muted mb-3">
          This booking has linked bookings.
          Select which booking you want to generate the voucher for:
        </p>

        {loading ? (
          <div className="text-center py-4">
            <Spinner animation="border" variant="primary" />
            <p className="text-muted mt-2">Loading linked bookings...</p>
          </div>
        ) : (
          <Table responsive striped bordered hover>
            <thead>
              <tr>
                <th>Reference</th>
                <th>Price</th>
                <th>Type</th>
                <th>Programme</th>
                <th style={{ width: '100px' }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {allBookings.map((booking) => {
                const typeInfo = BOOKING_TYPE_LABELS[booking.booking_type]
                  || BOOKING_TYPE_LABELS.transfer;
                return (
                  <tr key={booking.booking_reference}>
                    <td>
                      <strong>{booking.booking_reference}</strong>
                      {booking.booking_reference === order.booking_reference && (
                        <Badge bg="info" className="ms-2">Current</Badge>
                      )}
                    </td>
                    <td className="text-nowrap">
                      {thousandSeparator(booking.price)}
                      {' '}
                      {booking.currency}
                    </td>
                    <td>
                      <Badge bg={typeInfo.color}>
                        <i className={`fa ${typeInfo.icon} me-1`} />
                        {typeInfo.label}
                      </Badge>
                    </td>
                    <td>{booking.programme?.name || '-'}</td>
                    <td>
                      <Button
                        size="sm"
                        variant="primary"
                        onClick={() => handleSelect(booking)}
                      >
                        <i className="fa fa-file-alt me-1" />
                        Select
                      </Button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default LinkedBookingSelectorModal;
